import React from 'react';
import { Outlet } from 'react-router-dom';
import './styles.css';
import './responsive.css';

import ScrollToTop from './functions/ScrollToTop';

// Componentes
import Navbar from './components/Navbar';
import Whatsapp from './components/Whatsapp';


function NoFooterLayout() {
  return (
    <>
    <div className="App d-flex flex-column min-vh-100">
      <Navbar />
      <ScrollToTop />
      <main className="flex-grow-1">
        <Outlet />
      </main>
      <Whatsapp />
    </div>
    </>
  )
}

export default NoFooterLayout